<template>
  <div>
    <!-- ログイン後 -->
    <template v-if="user">
      <template v-for="item in items">
        <!-- 見出しあり -->
        <template v-if="item.title">
          <template v-if="item.invalid_domains.length === 0 || (user && item.invalid_domains.indexOf(user.domain) < 0)">
            <p class="head pl-6 mb-5 pr-2">{{ $t("message.home." + item.title) }}</p>
            <!-- ツールチップ判定 -->
            <v-tooltip v-if="item.tooltip" top :key="item.title">
              <template v-slot:activator="{ on }">
                <v-icon class="mb-1" size="20" v-on="on">mdi-help-circle-outline</v-icon>
              </template>
              <span>{{ $t("message.home."+ item.title + "_info") }}</span>
            </v-tooltip>

            <template v-for="(button,index) in item.button_items">
              <template v-if="(!button.requiresAuth || user)
                && (item.invalid_domains.length === 0 || (user && button.invalid_domains.indexOf(user.domain) < 0))
                && (!button.role || (user && button.role === user.role))">
                <!-- クエリパラメータを付与するボタン -->
                <template v-if="!!button.file_type">
                  <v-btn x-large block color="primary" dark class="mr-2 mb-5"
                    :class="index+1 === item.button_items.length ? 'mb-7' : ''"
                    @click="moveLink(button.route, button.file_type)" :key="button.title">
                    <v-icon class="pr-1">{{ button.icon }}</v-icon>{{ $t("message.home." + button.text) }}
                  </v-btn>
                </template>
                <!-- 通常のボタン -->
                <template v-else>
                  <v-btn x-large block color="primary" dark class="mr-2 mb-5"
                    :class="index+1 === item.button_items.length ? 'mb-7' : ''"
                    :to="button.route"
                    :key="button.text">
                    <v-icon class="pr-1">{{ button.icon }}</v-icon>{{ $t("message.home." + button.text) }}
                  </v-btn>
                </template>
              </template>
            </template>
          </template>
        </template>
        <!-- 見出しなし・枠なし -->
        <template v-else>
          <template v-for="button in item.button_items">
            <v-btn x-large outlined block dark class="mt-10 mr-2 mb-5 other_button" :to="button.route" :key="button.title">
              <v-icon class="pr-1">{{ button.icon }}</v-icon>{{ $t("message.home." + button.text) }}
            </v-btn>
          </template>
          <v-btn x-large outlined block dark class="mr-2 mb-5 other_button" @click="change_sideMenu"
            :key="item.route">{{ $t("message.home.menu") }}</v-btn>
        </template>
      </template>
    </template>
    <!-- ログイン前 -->
    <template v-else>
      <div class="mt-3">
        <template v-for="idp in idps">
          <v-btn x-large block color="primary" dark height="64"
            class="mr-2 mb-5"
            @click="login(idp.iid)" :key="idp.name">
            <v-icon class="pr-1">mdi-account-circle</v-icon>{{ $t("message.account.login_with", { "idp": idp.name } ) }}
          </v-btn>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { login } from "../js/login";

export default {
  data(){
    return {
      module_id: "57",
      items: [
        {
          "title": "translation_estimate",
          "tooltip": false,
          "invalid_domains": [],
          "button_items": [
            {
              "route": "/translate",
              "icon": "mdi-translate",
              "text": "translation_estimate",
              "requiresAuth": true,
              "invalid_domains": []
            },
            {
              "route": "/file",
              "icon": "",
              "text": "translation_results",
              "requiresAuth": true,
              "invalid_domains": [],
              "file_type": "translated"
            },
            {
              "route": "/file",
              "icon": "",
              "text": "estimate_results",
              "requiresAuth": true,
              "invalid_domains": [],
              "file_type": "source"
            },
          ],
        },
        {
          "title": "translation_engine",
          "tooltip": true,
          "invalid_domains": ['the-reading'],
          "button_items": [
            {
              "route": "/train",
              "icon": "mdi-brain",
              "text": "train",
              "requiresAuth": true,
              "invalid_domains": ['the-reading']
            },
            {
              "route": "/model",
              "icon": "",
              "text": "model",
              "requiresAuth": true,
              "invalid_domains": ['the-reading']
            },
          ]
        },
        {
          "tooltip": false,
          "invalid_domains": [],
          "button_items": [
            {
              "route": "/preference",
              "icon": "",
              "text": "preference"
            }
          ],
        },
      ],
    }
  },
  mixins: [login],
  computed: {
    ...mapGetters([
      'user',
      'idps',
      'domain'
    ])
  },
  methods: {
    change_sideMenu() {
      this.$store.commit("setSideMenu", !this.$store.getters.side_menu);
    },
    moveLink(route, type) {
      this.$router.push({ path: route, query: { file_type: type }})
    }
  },
}
</script>
<style lang="scss" scoped>
.head {
  display: inline-block;
  font-weight: bold;
  text-align: left;
}
.v-btn {
  max-width: 330px !important;
}
.other_button {
  background-color:#FFF !important;
  border: 1px solid #B2B2B2;
  color: rgba(0, 0, 0, 0.87);
}
.v-tooltip__content {
  background: gray;
  opacity: 1 !important;
  white-space: pre-wrap;
}

</style>
